import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useResetPassword() {
  const [loading, setLoading] = useState(false);

  async function execute(token: string, password: string, email: string) {
    try {
      setLoading(true);
      const response = await api.post(`/v1/backoffice/admins/${token}`, {
        token,
        email,
        password,
      });

      if (response.status === 201) {
        toast.success(ToastMessages.account.success.resetPassword);
        return;
      }
    } catch (error: any) {
      toast.success(ToastMessages.account.error.resetPassword);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
